<div
  class="d-flex flex-nowrap align-items-center"
  [ngClass]="{'toggle-wrapper rounded p-2 justify-content-between justify-content-md-end w-100': toggleOutline, 'selected': isToggleOn }">
  <div class="footnote me-2" *ngIf="toggleFilter.titleParts">
    <ng-container *ngFor="let part of toggleFilter.titleParts; let i = index">
      <ng-container [ngSwitch]="part.type">
        <ng-container *ngSwitchCase="'raw-text'">
          <span class="toggle-title-parts-text">{{ part.text }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'icon'">
          <flo-svg-icon [icon]="part" class="toggle-title-parts-icon"></flo-svg-icon>
        </ng-container>
        <ng-container *ngSwitchCase="'image'">
          <flo-image [image]="part" class="toggle-title-parts-image"></flo-image>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <label *ngIf="!toggleFilter.titleParts" class="footnote me-2">{{ toggleFilter.title }}</label>
  <a
    (click)="toggleClick()"
    floAnalytics
    [analyticsProperties]="toggleFilter.analytics"
    elementName="Toggle"
    eventName="Toggle Clicked"
  >
    <div
      data-test="toggle-filter"
      [ngClass]="isToggleOn ? 'toggle-bg bg-primary' : 'toggle-bg'">
      <div [@isToggleOn]="isToggleOn" class="toggle"></div>
    </div>
  </a>
</div>
